module.exports = __webpack_public_path__ + "static/media/paper_presentation.5c2efcc1.svg";